var map = {
	"./binance.svg": 536,
	"./check_circle.svg": 187,
	"./connect_disconnected.svg": 268,
	"./gas_price.svg": 537,
	"./gift.svg": 538,
	"./lock.svg": 539,
	"./protect.svg": 540,
	"./stats.svg": 541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1637;